import { useCallback } from "react";
import { useLocale } from "use-intl";

export function useFormatNumber() {
  const locale = useLocale();
  return useCallback(
    (value: number | null | undefined) => (value ?? 0).toLocaleString(locale),
    [locale],
  );
}
